import * as React from 'react';

import * as styles from './InlineFilter.css';

interface IInlineFilterProps extends React.PropsWithChildren {
  prefix?: React.ReactNode;
  postfix?: React.ReactNode;
}

export const InlineFilter: React.FC<IInlineFilterProps> = ({ prefix, postfix, children }) => {
  return (
    <div className={styles['container']}>
      {prefix && <span className={styles['prefix']}>{prefix}</span>}
      {children}
      {postfix && <span className={styles['postfix']}>{postfix}</span>}
    </div>
  );
};
